import { render, staticRenderFns } from "./GuardarCambiosButton.vue?vue&type=template&id=ac6413c4&"
import script from "./GuardarCambiosButton.vue?vue&type=script&lang=ts&"
export * from "./GuardarCambiosButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports